import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ErrorService } from "src/app/error.service";
import { ColumnChangeBO } from "../list/list.model";
import { ClientBO, ClientReturnBO, disablePortalBO, SendToPortalBO, EmployerEmployeeRelationshipTaxPercentBO } from "./client-parent.model";

@Injectable({
  providedIn: 'root'
})

export class ClientHttpService {
  constructor(private http: HttpClient, public errorService: ErrorService) {
  }

  getLOV(paramsData: URLSearchParams): Observable<any> {
    let url = "api/Lov/GetLovDropDown?";
    return this.http.get<[{ Key: string, Value: string }]>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getZipcode(paramsData: URLSearchParams): Observable<any> {
    let url = "api/Client/getZipcode?"
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
//  getValidateTaxPercentmessages(paramsData: URLSearchParams): Observable<string> {
//     let url = "api/EmployerEmployeeRelationship/validateClientRelTaxcheck?"
//     return this.http.get<string>(url + paramsData, { observe: 'response' ,responseType:'json'}).pipe(
//       map(data => data.body),
//       catchError(this.errorService.handleError)
//     )
//   }
  getValidateTaxPercentmessages(paramsData: URLSearchParams): Observable<string> {
  let url = "api/EmployerEmployeeRelationship/validateClientRelTaxcheck?";
  return this.http.get(url + paramsData.toString(), {
    observe: 'body',           
    responseType: 'text'       
  });
}
  saveClientData(list: ClientBO): Observable<ClientReturnBO> {
    let url = "api/Client/SaveClient";
    return this.http.post<ClientReturnBO>(url, list, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  GetLocationDropDown(): Observable<any> {

    let url = "api/Location/GetLocationDropDown";

    return this.http.get<any>(url, { observe: 'response' }).pipe(

      map(data => data.body),

      catchError(this.errorService.handleError)

    )

  }

  getClientStatusDropDown(): Observable<[{ Key: string, Value: string }]> {
    let url = "api/Client/getClientStatusDropDown?";
    return this.http.get<[{ Key: string, Value: string }]>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  savecolumwidth(list: ColumnChangeBO): Observable<any> {
    let url = "api/ColumnChange/Savewidth?";
    return this.http.post<any>(url, list, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  SentToClient(MailSend: SendToPortalBO): Observable<any> {
    let url = "api/Client/sendToClientPortal";
    return this.http.post<any>(url, MailSend, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)

    )
  }

  DisablePortal(DisableMail: disablePortalBO): Observable<any> {
    let url = "api/OnBoardProcessing/disableClientPortal";
    return this.http.post<any>(url, DisableMail, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )

  }

  // ...............................................RELATION TAX PERCENT..............................................................//



  ClientEmployeRelationShipDropDown(paramsData: URLSearchParams): Observable<any> {
    let url = "api/ClientRelationshipTax/CliEmpRelDropDown?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  ClientRelationShipDropDown(paramsData: URLSearchParams): Observable<any> {
    let url = "api/ClientRelationshipTax/CliRelDropDown?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  ClientRelationShipTaxDropDown(paramsData: URLSearchParams): Observable<any> {
    let url = "api/ClientRelationshipTax/CliRelTaxPerDropDown?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  saveupdaterelationtaxpercent(saveList: EmployerEmployeeRelationshipTaxPercentBO): Observable<EmployerEmployeeRelationshipTaxPercentBO> {
    let url = "api/ClientRelationshipTax/SaveEmpRelTaxPercent";
    return this.http.post<EmployerEmployeeRelationshipTaxPercentBO>(url, saveList, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  deleterelationtaxpercent(paramsData: URLSearchParams): Observable<number> {
    let url = "api/ClientRelationshipTax/DelEmployerEmpRelTaxPercent?"
    return this.http.delete<any>(url + paramsData).pipe(
      map(data => data),
      catchError(this.errorService.handleError))
  }

  getportalCreateCheck(paramsData: URLSearchParams): Observable<any> {
    let url = "api/Client/GetClientPortalLoginDetails?";
    return this.http.get(url + paramsData, { observe: 'response', responseType: "text" }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getExportCsv(): Observable<any> {
    let url = "api/Client/ClientSheetExport?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  ClientLanguageList(paramsData: URLSearchParams): Observable<any> {
    let url = "api/Client/clientLanList?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  //==============================get employee permission==========================================//
  getpermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
      //.............................GetFunctionwithResponseTypeText........................................
      GetFunctionwithResponseTypeText(params, url): Observable<any> {
        return this.http.get(url + params, { observe: 'response', responseType: "text" }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        );
    }

        //.............................saveorUpdateFunctionwithResponseTypeText........................................
      saveorUpdateFunctionwithResponseTypeText(saveList, url): Observable<any> {
          return this.http.post(url, saveList, { observe: 'response', responseType: "text" }).pipe(
              map(data => data.body),
              catchError(this.errorService.handleError)
          )
      }

      getClientServiceDropdown(paramsData: URLSearchParams): Observable<any> {
        let url = "api/VisitSchedule/GetClientServiceDropdownlist?";
        return this.http.get<any>(url + paramsData, { observe: "response" }).pipe(
          map((data) => data.body),
          catchError(this.errorService.handleError)
        );
      }

    //...................................get Payer Details..............................................................
      getPayerSourceDropdown(): Observable<any>{
        let url = "api/Payer/GetGroupPayorList";
        return this.http.get<any>(url, {observe: "response"}).pipe(
          map((data)=> data.body),
          catchError(this.errorService.handleError)
        );
      }

       getCFSSAgencyDropdown(): Observable<any>{
        let url = "api/CFSSAgency/cfssAgencyDropDown";
        return this.http.get<any>(url, {observe: "response"}).pipe(
          map((data)=> data.body),
          catchError(this.errorService.handleError)
        );
      }
       getClientSupportDropdown(): Observable<any>{
        let url = "api/CFSSAgency/cfssAgencyDropDown";
        return this.http.get<any>(url, {observe: "response"}).pipe(
          map((data)=> data.body),
          catchError(this.errorService.handleError)
        );
      }
      ////////////////////// upload Client Documents //////////////////////////////////////////////////
      uploadClientDocument(body: any): Observable<any>{
        return this.http.post('api/Document/UploadDocument', body, { observe: 'response', responseType: "text" }).pipe(
          map(data => data.body),
          catchError(this.errorService.handleError)
        )
      }
      deleteClientDocument(paramsData: URLSearchParams): Observable<any>{
        let url = "api/Document/DeleteDocument?"
        return this.http.delete(url + paramsData, {observe: "response", responseType: "text"}).pipe(
          map(data => data.body),
          catchError(this.errorService.handleError)
        )
      }
      downloadClientDocument(paramsData: URLSearchParams): Observable<any>{
        let url = "api/Document/DownloadDocument?";
        return this.http.get(url+paramsData, {observe: "response", responseType: "text"}).pipe(
          map(data => data.body),
          catchError(this.errorService.handleError)
        )
      }
      getClientDocumentBase64(paramsData: URLSearchParams): Observable<any>{
        let url = "api/Document/GetDocumentBase64?";
        return this.http.get(url + paramsData, {observe: "response",  responseType: "text"}).pipe(
          map(data => data.body),
          catchError(this.errorService.handleError)
        )
      }
}



